import {
  PLATFORM_PLACEMENTS,
  type PreflightPlacementCode,
  type PreflightPlatformCode,
} from "@nexus/contracts";

/**
 * Placement options valid for a platform, driven by the contract (changing platform
 * clears placement). Display labels for platforms, placements, statuses, and bands are
 * i18n keys resolved at the call site via `t("preflight.<group>.<code>")` (KTD14).
 */
export function placementsForPlatform(
  platform: PreflightPlatformCode,
): readonly PreflightPlacementCode[] {
  return PLATFORM_PLACEMENTS[platform];
}

/**
 * A platform with a single placement offers no choice, so asking for one is busywork
 * that also blocks submission until it is answered. Null whenever there is a real pick.
 */
export function onlyPlacementFor(
  platform: PreflightPlatformCode,
): PreflightPlacementCode | null {
  const placements = placementsForPlatform(platform);
  return placements.length === 1 ? (placements[0] ?? null) : null;
}
